import Statechart from './statechart.js';
import {
  CHAT_TYPE_OFFLINE, CHAT_TYPE_PUBLIC, CHAT_TYPE_PRIVATE, CHAT_TYPE_SPY, CHAT_TYPE_PLEDGE
} from './const.js';
import {fixPledgeEndTime, exponentialBackoff} from './utils.js';
import grayLog from './graylog.js';


export const createChatHSM = (chatObj, ws_emitter, ui_emitter, storeController, chat_server_address) => {

  const store = ev => storeController.store.dispatch(ev);
  const ws_send = ev => chatObj.edgeConnection.send(ev);
  let skipFirstTimeGetHistory = true; // do not ask chat messages already rendered in html

  return Object.assign({}, Statechart(), {
    chat_target_state: 'NO_CHAT',
    connection_retry_count: 5,
    user_login_info: null,
    presence_login_response: null,
    chatroom_login_action: {
      action: 'login',
      room: undefined, // will be set later with room request
      login_info: {
        uid: undefined, // will be set later with presence_login_success
        cwt: undefined, // will be set later with presence_login_success
        spy: false,
        truePrivateChat: false,
        client_version: 'ws/1'
      }
    },
    pledge_chat_info: null, // room info about active pledge show
    /*  ***
        presence_login_success
        presence_login_error
        presence_login_timeout
        presence_performers
        presence_join_performer
        presence_leave_performer
        presence_change_status_performer
        presence_vibratip_setting
        presence_add_stream
        presence_delete_stream
        presence_answer_private_chat_invitation
        presence_private_chat_info
        presence_user_account_info
        presence_my_pledge_bids
        presence_pledge_configuration
        presence_pledge_bid_success
        presence_pledge_bid_error
        presence_pledge_bid_refund
        presence_pledge_chat_info
    */

    //
    initialState: 'SUPERSTATE',
    states: {
      SUPERSTATE: {
        init: 'CONNECTING',
        'user_login_credentials': function (login_info) {
          // that's when API Object sets user credentials
          // for instance after /autoLogin or something similar
          this.user_login_info = login_info;
          console.log('save login info', login_info);
        },
        'public_chat_login_request': function (chatroom_name) {
          // the only event that UI may post to join public chat,
          // all other chats are activated with some events from presence
          this.chat_target_state = 'PUBLIC';
          this.chatroom_login_action.room = chatroom_name;
          this.chatroom_login_action.login_info.spy = false;
          this.dispatch('chat_login_request');
        },
        'ws_closed': function () {
          // TODO: what should we do if socket Closed?,
          // when and how exactly that may happen?
          console.warn('what should we do if socket closed?',this.connection_retry_count);
          this.connection_retry_count--;
          this.chat_target_state = 'PUBLIC';
          if (this.connection_retry_count) {
            return 'TRY_RECONNECT_AND_GIVE_UP'
          }  else {
            return 'OFFLINE'
          }

        },
        'ws_error': function () {
          // TODO: what should we do if socket "Errored"?,
          // when and how exactly that may happen?
          console.warn('what should we do if socket has an error?');
          return 'OFFLINE'
        },

        states: {
          OFFLINE: {
            // public_chat: {target: 'PUBLIC'},
          },
          TRY_RECONNECT_AND_GIVE_UP: {
            entry: function () {
              chatObj.messenger.needRestartAfterWsDisconnect = true; // tell messenger to restart after presence_login and presence_performers
              this.back_off_time = 500;
              this.reconnecting = setTimeout(() => {
                chatObj.edgeConnection.connect_to(chat_server_address);
              }, this.back_off_time);
            },
            'ws_error': function () {
              this.connection_retry_count--;
              this.back_off_time += 1500;
              if (this.connection_retry_count) {
                this.reconnecting = setTimeout(() => {
                  chatObj.edgeConnection.connect_to(chat_server_address);
                }, this.back_off_time);
              } else {
                return 'OFFLINE'
              }
            },
            'ws_closed': function () {
              // this.connection_retry_count--;
              // we ignore closed event while reconnecting
            },
            'ws_connected': {
              'target': 'CONNECTED'
            },
            exit: function () {
              clearTimeout(this.reconnecting);
            }
          },
          CONNECTING: {
            entry: function () {
              chatObj.edgeConnection.connect_to(chat_server_address);
            },
            'ws_connected': {
              'target': 'CONNECTED'
            },
            states: {}
          },
          CONNECTED: {
            init: 'WAIT_USER_CREDENTIALS',
            entry: function () {
              if (this.user_login_info) {
                this.dispatch('user_login_credentials', [this.user_login_info]);
              }
            },
            states: {
              WAIT_USER_CREDENTIALS: {
                user_login_credentials: function (user_info) {
                  ws_send({
                    'action': 'presence_login',
                    'login_info': {
                      'uid': user_info.hash,
                      'cwt': user_info.cwt,
                      'client_version': 'ws/1'
                    },
                  });
                  return 'WAIT_PRESENCE_LOGIN';
                }
              },
              WAIT_PRESENCE_LOGIN: {
                'presence_login_success': function (presence_login_response) {
                  console.info('save presence login', presence_login_response);
                  this.presence_login_response = presence_login_response.user;
                  this.chatroom_login_action.login_info.uid = presence_login_response.user.uid;
                  this.chatroom_login_action.login_info.cwt = presence_login_response.user.cwt;

                  return 'PRESENCE_READY'
                },
                'presence_login_error': {
                  'target': 'OFFLINE'
                }
              },
              PRESENCE_READY: {
                init: 'NO_CHAT',
                /*'presence_private_chat_info': function () {

                },
                'performer_start_pledge_show': function () {

                },*/

                'chat_login_request': function () {
                  // this.chatroom_login_action.room = chatroom_name;
                  // this.chatroom_login_action.login_info.spy = spy;
                  this.chatroom_login_action.login_info.truePrivateChat = chatObj.getPerformer().true_private_setting;
                  console.log('chat_login_request', 'target state=', this.chat_target_state, this.chatroom_login_action);
                  ws_send(this.chatroom_login_action);
                  grayLog.log('chat_login');
                  return 'WAIT_CHAT_LOGIN'
                },

                presence_my_pledge_bids: function (data) {
                  // check if we have active pledge show running
                  const {pledge_bids} = data;
                  const performerId = chatObj.getPerformer().id;
                  this.pledge_chat_info = null;
                  pledge_bids.some(pb => {
                    if (pb.user_id == performerId && pb.pledge_chat_info) {
                      this.pledge_chat_info = pb.pledge_chat_info;
                      return true;
                    }
                  });
                },

                states: {
                  NO_CHAT: {
                    entry: function () {
                      ws_send({ action: 'presence_get_performers' });
                      chatObj.messenger.setupAvailabilityPresence();
                      if (this.chat_target_state && this.chat_target_state !== 'NO_CHAT') {
                        this.dispatch('chat_login_request');
                      }
                    },
                  },
                  WAIT_CHAT_LOGIN: {
                    entry: function () {
                      // this.chat_target_state
                    },
                    exit: function () {

                    },
                    login_success: function (event) {
                      console.log('login_success', event);
                      store(storeController.user.actions.update_user_from_chat_server(event.user));
                      let cts = this.chat_target_state ;
                      // we should always clear target state after leaving WAIT_CHAT_LOGIN
                      // because it is one-off action.
                      this.chat_target_state = false;
                      grayLog.log('chat_login_success');
                      return cts;
                    },
                    login_error: function (event) {
                      this.chat_target_state = false;
                      grayLog.warning('chat_login_error');
                      return 'NO_CHAT'
                    },

                  },
                  CHAT: {
                    entry: function () {
                      // that sets current room in store
                      const chatroom_name = this.chatroom_login_action.room;
                      store(storeController.chat.actions.room(chatroom_name));
                      chatObj.messenger.setupAvailabilityChatRoom(chatroom_name);
                      ui_emitter.dispatchEvent(new CustomEvent('chat_connected')); // UI event
                      grayLog.log('chat_get_users');
                      ws_send({action: 'get_users', room: chatroom_name});
                      if (!skipFirstTimeGetHistory) ws_send({action: 'get_history', room: chatroom_name});
                      skipFirstTimeGetHistory = false;
                    },
                    exit: function () {
                      store(storeController.chat.actions.type(CHAT_TYPE_OFFLINE));
                      ui_emitter.dispatchEvent(new CustomEvent('chat_disconnected'));
                      ws_send({action: 'logout', room: chatObj.getRoom()});
                    },
                    user_return_to_public: function () {
                      this.chat_target_state = 'PUBLIC';
                      this.chatroom_login_action.login_info.spy = false;
                      this.chatroom_login_action.room = chatObj.getPerformer().public_room;
                      return 'NO_CHAT';
                    },
                    chat_stopped: function (event) {
                      const {room, message} = event;
                      if (message === 'kicked') {
                        ui_emitter.dispatchEvent(new Event('chat_user_kick'));
                      } else {
                        this.chat_target_state = 'PUBLIC';
                        this.chatroom_login_action.login_info.spy = false;
                        this.chatroom_login_action.room = chatObj.getPerformer().public_room;
                        return 'NO_CHAT';
                      }
                    },
                    presence_pledge_configuration: function (data) {
                      const {pledge_configuration, user_id, server_time} = data;
                      // fix time difference
                      fixPledgeEndTime(pledge_configuration, server_time);
                      store(storeController.performers.actions.performer_pledge_configuration(data));
                      if (!pledge_configuration) {
                        store(storeController.pledgeBids.actions.pledgeBidClear(user_id));
                      }
                      if (user_id == chatObj.getPerformer().id) {
                        this.dispatch('performer_pledge_configuration', [pledge_configuration]);
                      }
                    },
                    presence_pledge_chat_info: function (data) {
                      const {user_id, pledge_chat_info} = data;
                      store(storeController.pledgeBids.actions.pledgeChatInfo({user_id, pledge_chat_info}));
                      if (user_id == chatObj.getPerformer().id) {
                        const pledge_chat_info = chatObj.getPledgeChatInfo();
                        if (pledge_chat_info) {
                          this.dispatch('performer_start_pledge_show', [pledge_chat_info])
                        }
                      }
                    },
                    states: {
                      PUBLIC: {
                        init: 'SIMPLE_CHAT',
                        entry: function () {
                          store(storeController.chat.actions.type(CHAT_TYPE_PUBLIC));
                          const performer = chatObj.getPerformer();
                          ui_emitter.dispatchEvent(new CustomEvent('chat_public_enter', {detail: {performer}}));
                          if (!this.pledge_chat_info) {
                            // add camAccess parameter, same as in redux-store.js
                            let camAccess = false;
                            const { chat, hiddenCamAccess } = storeController.store.getState();
                            const room = chat.room;
                            const hca = hiddenCamAccess;
                            if (room in hca) camAccess = hca[room].allowed;
                            const detail = { performer, camAccess };
                            // do not stop webcam if user should go to running pledge show
                            ui_emitter.dispatchEvent(new CustomEvent('chat_public_performer_' + performer.status, {detail}));
                          }

                          if (this.pledge_chat_info) {
                            this.dispatch('performer_start_pledge_show', [this.pledge_chat_info]);
                            this.pledge_chat_info = null;
                          } else if (performer.pledge_configuration) {
                            this.dispatch('performer_pledge_configuration', [performer.pledge_configuration]);
                          }
                        },
                        exit: function () {
                          const performer = chatObj.getPerformer();
                          ui_emitter.dispatchEvent(new CustomEvent('chat_public_exit', {detail: {performer}}));
                        },
                        presence_private_chat_info: function (evt) {
                          const {private_chat_info, user_id, join_mode} = evt;
                          if (join_mode === 'private') {
                            this.chat_target_state = 'PRIVATE';
                            this.chatroom_login_action.room = private_chat_info.room;
                            this.chatroom_login_action.login_info.spy = false;
                            return 'NO_CHAT';
                          } else if (join_mode === 'spy') {
                            this.chat_target_state = 'SPY';
                            this.chatroom_login_action.room = private_chat_info.room;
                            this.chatroom_login_action.login_info.spy = true;
                            return 'NO_CHAT'
                          }
                        },
                        performer_pledge_configuration: function (pledge_configuration) {
                          if (pledge_configuration) {
                            return pledge_configuration.started ? 'PLEDGE_SHOW' : 'PLEDGE_INIT';
                          } else {
                            return 'SIMPLE_CHAT';
                          }
                        },
                        performer_start_pledge_show: function (pledge_chat_info) {
                          this.chat_target_state = 'PLEDGE';
                          this.chatroom_login_action.room = pledge_chat_info.room;
                          this.chatroom_login_action.login_info.spy = false;
                          return 'NO_CHAT';
                        },
                        states: {
                          SIMPLE_CHAT: {
                            entry: function () {

                            },
                          },
                          PLEDGE_INIT: {
                            entry: function () {
                              const performer = chatObj.getPerformer();
                              ui_emitter.dispatchEvent(new CustomEvent('chat_public_performer_pledge_init_enter', {detail: {performer}}));
                            },
                            exit: function () {
                              const performer = chatObj.getPerformer();
                              ui_emitter.dispatchEvent(new CustomEvent('chat_public_performer_pledge_init_exit', {detail: {performer}}));
                            }
                          },
                          PLEDGE_SHOW: {
                            entry: function () {
                              const performer = chatObj.getPerformer();
                              ui_emitter.dispatchEvent(new CustomEvent('chat_public_performer_pledge_show_enter', {detail: {performer}}));
                            },
                            exit: function () {
                              const performer = chatObj.getPerformer();
                              ui_emitter.dispatchEvent(new CustomEvent('chat_public_performer_pledge_show_exit', {detail: {performer}}));
                            }
                          }
                        },
                      },
                      PRIVATE: {
                        entry: function () {
                          store(storeController.chat.actions.type(CHAT_TYPE_PRIVATE));
                          const performer = chatObj.getPerformer();
                          ui_emitter.dispatchEvent(new CustomEvent('chat_private_enter', {detail: {performer}}));
                        },
                        exit: function () {
                          const performer = chatObj.getPerformer();
                          ui_emitter.dispatchEvent(new CustomEvent('chat_private_exit', {detail: {performer}}));
                        },
                      },
                      SPY: {
                        entry: function () {
                          store(storeController.chat.actions.type(CHAT_TYPE_SPY));
                          const performer = chatObj.getPerformer();
                          ui_emitter.dispatchEvent(new CustomEvent('chat_spy_enter', {detail: {performer}}));
                        },
                        exit: function () {
                          const performer = chatObj.getPerformer();
                          ui_emitter.dispatchEvent(new CustomEvent('chat_spy_exit', {detail: {performer}}));
                        },
                      },
                      PLEDGE: {
                        entry: function () {
                          store(storeController.chat.actions.type(CHAT_TYPE_PLEDGE));
                          const performer = chatObj.getPerformer();
                          ui_emitter.dispatchEvent(new CustomEvent('chat_pledge_enter', {detail: {performer}}));
                        },
                        exit: function () {
                          const performer = chatObj.getPerformer();
                          ui_emitter.dispatchEvent(new CustomEvent('chat_pledge_exit', {detail: {performer}}));
                        },
                      }
                    }
                  },
                }
              }
            }
          },


        }
      }
    },
  });

};

